import { set, get, find, sortBy } from 'lodash';
import { createSelector } from 'reselect';

const getParentIds = (list, current) => {
  if (!get(current, 'parent_roles.length')) return [];

  return current.parent_roles.reduce(
    (res, { id }) => [...res, id, ...getParentIds(list, find(list, { id }))],
    [],
  );
};

export const getRolesOptions = createSelector(
  state => state.roles.list,
  state => state.roles.current,
  (list, current) => {
    const idsToRemove = [get(current, 'id'), ...getParentIds(list, current)];

    const rolesOptions = list
      .filter(({ id }) => !idsToRemove.includes(id))
      .map(({ name, id, description }) => ({
        label: name,
        value: id,
        description,
      }));

    return sortBy(rolesOptions, ({ label }) => label.toLowerCase());
  },
);

const isModelsAttribute = name => {
  return name.match(/\./g);
};

const permissionsToModelsReducer = (result, { resource, value, scope }) => {
  if (isModelsAttribute(resource)) {
    const path = resource.replace('.', '.columns.');

    set(result, `${scope}.${path}`, value);
  } else {
    set(result, `${scope}.${resource}.value`, value);
  }

  return result;
};

const formatRole = ({ name, id, description }) => ({
  label: name,
  value: id,
  description,
});

export const getPreparedCurrentRole = createSelector(
  state => state.roles.current,
  current => {
    const {
      name,
      description,
      assigned_roles: assigned,
      assigned_permissions: permissions,
    } = current || {};
    const res = current
      ? {
          role: { name, description },
          assigned_permissions: permissions,
          ...(assigned && { assigned_roles: assigned.map(formatRole) }),
          ...(permissions && {
            models: permissions
              .filter(({ resource, scope }) => resource !== scope)
              .reduce(permissionsToModelsReducer, {}),
            apps: permissions
              .filter(({ resource, scope }) => resource === scope)
              .reduce(permissionsToModelsReducer, {}),
          }),
        }
      : {};

    return res;
  },
);

export const isCurrentRoleDefault = createSelector(
  state => state.roles.current,
  role => !get(role, 'user_defined', true),
);
